// form
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { useI18n } from 'iomart-hooks';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  symbol?: string;
};

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.floatValue || 0,
            },
          });
        }}
        thousandSeparator=" "
        prefix=""
        decimalScale={3}
        allowNegative={false}
      />
    );
  }
);

export default function RHFFloat({ name, symbol = '', helperText, ...other }: Props) {
  const { control } = useFormContext();
  const { t } = useI18n(false);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error ? error?.message : helperText}
          InputProps={{
            inputComponent: NumericFormatCustom as any,
            endAdornment: symbol && (
              <InputAdornment
                position="end"
                sx={{ pt: 0.3, '.MuiTypography-root': { fontSize: '12px' } }}
              >
                {t(symbol)}
              </InputAdornment>
            ),
          }}
          {...other}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{
            ...other.sx,
            '& .MuiInputBase-input': {
              font: 'menu',
            },
          }}
        />
      )}
    />
  );
}
